import React, { useState } from "react";
import AddProspect from "./AddProspect";
import { useOutletContext } from "react-router-dom";

function Opportunities({ data }) {
  const [showAddProspect, setShowAddProspect] = useState(false);
  const [companyinfo_id, setCompanyinfo_id] = useState(null);
  return (
    <>
      {showAddProspect && companyinfo_id && (
        <AddProspect
          onClose={() => setShowAddProspect(false)}
          companyinfo_id={companyinfo_id}
        />
      )}
      <div className="p-1 opportunities-scroll">
        {data.length > 0 ? (
          data.map((item, index) => (
            <>
              <div key={index} className="p-2 mb-2 alert alert-primary">
                <div className="d-flex align-items-center justify-content-between p-1 text-dark">
                  <div className="d-flex">
                    <span className="fa-solid fa-triangle-exclamation text-warning d-inline-flex mt-1 fs-14 me-2"></span>
                    <div>
                      <p className="text-truncate mb-0">
                        <span className="fw-bold fs-13 text-dark mb-1 me-1">
                          {item?.firstname + " " + item?.lastname}
                        </span>
                        <span className="text-muted fs-12 fw-medium me-1">
                          has left
                        </span>
                        <span className="fw-bold fs-13 text-dark mb-1 me-1">
                          {item?.prev_company_name}
                        </span>
                      </p>
                      <p className="text-truncate op-7 fs-11 mb-0">
                        <span className="text-muted me-1">Now at</span>
                        <span className="fw-bold text-dark mb-1 me-1">
                          {item?.current_company_name}
                        </span>
                      </p>
                      <p className="text-truncate op-1 fs-11 d-flex">
                        <i className="fa-solid fa-arrow-right-long me-1 op-7"></i>
                        <span className="text-muted me-1">
                          Consider adding <b>{item?.current_company_name}</b> as
                          a new prospect
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="">
                    <button
                      onClick={() => {
                        setCompanyinfo_id(item?.current_companyinfo_id);
                        setShowAddProspect(true);
                        console.log(item?.current_companyinfo_id);
                      }}
                      type="button"
                      className="btn btn-outline-warning rounded-pill"
                    >
                      Add as Prospect
                    </button>
                  </div>
                </div>
              </div>
            </>
          ))
        ) : (
          <span className="text-danger">No Data Available</span>
        )}
      </div>
    </>
  );
}

export default Opportunities;
